module.exports = __webpack_public_path__ + "img/mars-double.92446e85.svg";